<template>
    <b-container fluid style="margin-top: 60px">
        <div class="form-inline">
            <h1 v-on:click="reloadData">
                {{ formTitle }} &nbsp;
                <b-button
                    class="bgc_aux_normal"
                    v-b-tooltip.hover
                    :title="$t('com_showdata', { ns: 'common' })"
                    ><font-awesome-icon icon="arrow-down" size="1x" />
                </b-button>
            </h1>
        </div>
        <b-row>
            <b-col sm="12">
                <div v-if="showFilter">
                    <b-row no-gutters>
                        <b-col lg="6" class="my-1">
                            <b-form-group
                                :label="$t('com_filter', { ns: 'common' })"
                                label-for="filter-input"
                                label-cols-sm="3"
                                label-align-sm="right"
                                label-size="sm"
                                class="mb-0"
                            >
                                <b-input-group size="sm">
                                    <b-form-input
                                        id="filter-input"
                                        v-model="filter"
                                        type="search"
                                        :placeholder="
                                            $t('com_typetosearch', {
                                                ns: 'common'
                                            })
                                        "
                                    ></b-form-input>

                                    <b-input-group-append>
                                        <b-button
                                            :disabled="!filter"
                                            @click="filter = ''"
                                            >{{
                                                $t('com_wis', { ns: 'common' })
                                            }}</b-button
                                        >
                                    </b-input-group-append>
                                </b-input-group>

                                <b-input-group size="sm">
                                    <b-button
                                        v-if="
                                            checkRight('CheeseTreatmentCreate')
                                        "
                                        size="sm"
                                        @click="newRecipe"
                                        class="mr-1"
                                        ><font-awesome-icon
                                            icon="folder-plus"
                                            size="1x"
                                        />
                                        {{ strNieuw }}
                                    </b-button>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col lg="6" class="my-1">
                            <b-form-group
                                :label="$t('com_perpagina', { ns: 'common' })"
                                label-for="per-page-select"
                                label-cols-sm="6"
                                label-cols-md="4"
                                label-cols-lg="3"
                                label-align-sm="right"
                                label-size="sm"
                                class="mb-0"
                            >
                                <b-form-select
                                    id="per-page-select"
                                    v-model="perPage"
                                    :options="pageOptions"
                                    size="sm"
                                ></b-form-select>
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                    align="fill"
                                    size="sm"
                                    class="my-0"
                                ></b-pagination>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <b-input-group>
                        <b-button
                            v-if="checkRight('CheeseTreatmentCreate')"
                            size="sm"
                            @click="newRecipe"
                            class="mr-1"
                            ><font-awesome-icon icon="folder-plus" size="1x" />
                            {{ strNieuw }}
                        </b-button>
                    </b-input-group>
                </div>

                <b-table
                    :items="groupedDisplayList"
                    :fields="visibleFields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    stacked="md"
                    show-empty
                    :empty-text="$t('com_geen_data', { ns: 'common' })"
                    small
                    striped
                    @filtered="onFiltered"
                    @row-clicked="toonItems"
                >
                    <template v-slot:cell(actions)="row">
                        <b-button
                            v-if="checkRight('CheeseTreatmentCreate')"
                            size="sm"
                            @click="addRecipe(row.item)"
                            class="bgc_aux_normal"
                            ><font-awesome-icon icon="folder-plus" size="1x" />
                        </b-button>
                        <b-button
                            v-if="checkRight('CheeseTreatmentCreate')"
                            size="sm"
                            @click="editRecipe(row.item)"
                            class="bgc_aux_warning"
                            ><font-awesome-icon icon="edit" size="1x" />
                        </b-button>
                        <b-button
                            size="sm"
                            @click="toonItems(row.item)"
                            class="bgc_aux_unknown"
                            ><font-awesome-icon icon="info-circle" size="1x" />
                        </b-button>
                    </template>

                    <template v-slot:row-details>
                        <b-card no-body class="mb-1">
                            &nbsp;
                            <b-table
                                striped
                                responsive
                                :fields="visibleDetailFields"
                                :items="itemList"
                                primary-key
                            >
                            </b-table>
                        </b-card>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <treatment-recipe-modal
            v-if="detailsVisible"
            v-model="detailsVisible"
            :treatmentRecipeId="currentID"
            :treatmentRecipe="currentObject"
            @hide="reset"
            @change="applyChange"
        />
    </b-container>
</template>

<script lang="ts">
import _ from 'lodash';
import TreatmentRecipeModal from './TreatmentRecipeModal.vue';
import { defineComponent } from 'vue';
import DateHelper from '@/models/DateHelper';
import { loadList, loadItem } from '../../models/DataHelper';
import { TreatmentActivity, TreatmentRecipe } from '@/models/CheeseTreatment';
import { Permission } from '../../models/Permissions';
import { VueExtension } from '../../models/VueExtension';

export default defineComponent({
    name: 'TreatmentRecipeBase',
    data: function () {
        return {
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [10, 20, 40, { value: 100, text: '100' }],
            filter: null,
            filterOn: [],
            currentID: -1,
            recipeID: -1,
            currentObject: {} as TreatmentRecipe | null,
            detailsVisible: false,
            recipeVisible: false,
            localItemslist: [],
            displayFilterCount: 20,
            aangeraakt: 0,

            showScanner: false,
            showDetails: false,
            van: null,
            tot: null,
            dag: 'day',
            isDagInfo: true,
            selectDays: null,
            periodeDagen: 1,
            editDagen: -4,
            forceRefresh: false,
            activitiesList: [] as Array<TreatmentActivity>,
            strNotInList: this.$t('prod_nietinlijst', {
                ns: 'production',
                val: this.$t('com_batch', { ns: 'common' })
            }),
            strNieuw: this.$t('com_newx', {
                ns: 'common',
                val: this.$t('prod_treatmentschema', {
                    ns: 'production'
                })
            })
        };
    },
    props: {},
    components: {
        TreatmentRecipeModal
    },
    computed: {
        formTitle(): string {
            return this.$t('prod_treatmentschemas', { ns: 'production' });
        },
        showFilter(): boolean {
            return this.displayList
                ? this.displayList.length > this.displayFilterCount
                : false;
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                { key: 'id', label: 'id', sortable: false, visible: false },
                {
                    key: 'naam',
                    label: this.$t('com_naam', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'opmerking',
                    label: this.$t('com_opmerking', { ns: 'common' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        visibleDetailFields() {
            const fieldsInit = [
                {
                    key: 'stapnummer',
                    label: this.$t('prod_step', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'stap',
                    label: this.$t('prod_treatment', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'wachttijd',
                    label: this.$t('prod_wachttijd', { ns: 'production' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        displayList() {
            const tempList = this.activitiesList;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.totalRows = tempList ? tempList.length : 0;
            return tempList;
        },
        groupedDisplayList() {
            const a = this.aangeraakt;
            if (this.displayList == undefined) return null;
            const x = _(this.displayList.slice(0))
                .groupBy((x) => x.id)
                .map((value, key) => {
                    return {
                        id: value[0].id,
                        naam: value[0].naam,
                        opmerking: value[0].opmerking,
                        items: value
                    };
                })
                .value();
            return x;
        },
        itemList() {
            return this.localItemslist;
        },
        allowEdit() {
            // todo: wat worden de regels hiervoor?
            const editDate = new Date();
            editDate.setDate(editDate.getDate() - this.editDagen);
            const tempDate = new Date(editDate).toISOString().substring(0, 10);
            //const magNog = this.van ? tempDate < this.van : true;
            return true;
        }
    },
    methods: {
        toonItems(row) {
            if (row._showDetails) {
                this.$set(row, '_showDetails', false);
            } else {
                this.groupedDisplayList.forEach((row) => {
                    this.$set(row, '_showDetails', false);
                });
                this.localItemslist = row.item ? row.item.items : row.items;
                this.$set(row, '_showDetails', true);
            }
        },
        newRecipe() {
            this.addRecipe(null);
        },
        addRecipe(item) {
            this.currentID = -1;
            this.currentObject = item ? this.maakBehandelRecept(item) : null;
            this.detailsVisible = true;
        },
        editRecipe(item) {
            this.currentID = item ? parseInt(item.id) : -1;
            this.currentObject = item ? this.maakBehandelRecept(item) : null;
            this.detailsVisible = true;
        },
        maakBehandelRecept(item): TreatmentRecipe {
            const recipe = new TreatmentRecipe(item);
            recipe.stappen = item.items;
            return recipe;
        },
        async applyChange(refresh) {
            if (refresh) {
                this.forceRefresh = true;
                this.reset();
                this.reloadData();
            }
        },
        reset() {
            this.currentID = -1;
            this.currentObject = null;
            this.detailsVisible = false;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        setNewDates(selDates) {
            const refreshData =
                this.van != selDates.van ||
                this.tot != selDates.tot ||
                this.dag != selDates.dag;
            this.van = selDates.van;
            this.tot = selDates.tot;
            this.dag = selDates.dag;
            this.isDagInfo = selDates.dag == 'day';
            if (refreshData) {
                this.forceRefresh = true;
                this.reloadData();
            }
        },
        async reloadData() {
            const tempList = await loadList(
                'treatment/getTreatmentRecipes',
                'treatment/loadTreatmentRecipes',
                null,
                this.forceRefresh,
                this.$t
            );
            tempList.forEach((t) => {
                this.$set(t, '_showDetails', false);
            });
            this.totalRows = tempList ? tempList.length : 0;
            this.activitiesList = tempList;
            this.forceRefresh = false;
        },
        checkRight(recht) {
            const id = Permission.enum(recht);
            return (this.$root as VueExtension).handleRight(id);
        },
        displayDate(value) {
            return DateHelper.convertedToDate(value, true);
        }
    },
    mounted() {
        // Set the initial number of items
        this.reloadData();
        this.totalRows = this.displayList ? this.displayList.length : 0;
    },
    async created() {
        const lijst = await loadList(
            'masterdata/getConstantsLijst',
            'masterdata/loadApplicationConstants',
            null,
            this.forceRefresh,
            this.$t
        );
        const con = lijst
            ? lijst.find((x) => x.text == window.constants.APPCONST_EDITDAYS)
            : null;
        this.editDagen = con ? con.value : 30;
    }
});
</script>

<style scoped></style>

